import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=4b4e9a97&scoped=true"
import script from "./introduction.vue?vue&type=script&lang=js"
export * from "./introduction.vue?vue&type=script&lang=js"
import style0 from "./introduction.vue?vue&type=style&index=0&id=4b4e9a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e9a97",
  null
  
)

export default component.exports